module.exports = __webpack_public_path__ + "static/media/procesni-kriz.fd3164c7.jpg";